import React, { useEffect, useState } from 'react'
import seqStore from '../../store/seqStore'

export default function EuclideanIcon() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)

    const [fillColour, setFillColour] = useState('#FFB72C')

    useEffect(() =>{
        switch(currentTrack) {
            case 0:
                setFillColour('#FFB72C')
                break
            case 1:
                setFillColour('#FC4B4B')
                break
            case 2:
                setFillColour('#47BE61')
                break
            case 3:
                setFillColour('#1A8DF8')
                break
            default: setFillColour('#FFB72C')
        }
    }, [currentTrack])

    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8284 11.8284C11.3544 12.3025 10.7909 12.6327 10.1924 12.819L10.1923 17.9211C12.0837 17.6697 13.9106 16.8173 15.3639 15.364C18.8787 11.8493 18.8787 6.15077 15.3639 2.63604C11.8492 -0.878692 6.15073 -0.878671 2.63602 2.63604C-0.878687 6.15075 -0.878709 11.8492 2.63602 15.364C3.93112 16.6591 5.5228 17.477 7.19238 17.8176V12.5695C6.82435 12.383 6.47915 12.136 6.17156 11.8284C4.60944 10.2663 4.60946 7.73367 6.17156 6.17157C7.73365 4.60948 10.2663 4.60946 11.8284 6.17157C13.3905 7.73369 13.3905 10.2663 11.8284 11.8284Z" fill={fillColour}/>
        </svg>
    )
}
